import React, { useEffect, useRef, useState } from 'react';

import ReactSlider from 'react-slider';

import styles from './index.module.less';

import { Api } from '@apis/client';
import Http from '@helpers/Http';
import Filter from '@helpers/Filter';
import {
  locationType,
  defaultPoint
} from '@helpers/Constants';
import BrowserHistory from '@helpers/BrowserHistory';
import FridayService from '@services/friday';
import { getDistance, getFillPoints } from './utils';
import { transformToBd09 } from '@utils/mapUtil';

import NavBar from '@components/NavBar';
import BaseMap, { CustomOverlay } from '@components/map/Map/BaseMap';

import DateBar from './DateBar';

import {
  getStageTime,
  checkIsStagePoint
} from './utils';
import defaultAvatar from '@images/avatar_default.png';

const MovePath = () => {
  const params = useRef(Filter.urlParams(window.location.search));
  const mapRef = useRef(null);
  const renderMarks = useRef(false);
  const [sliderValue, setSliderValue] = useState(0);
  const [points, setPoints] = useState(null);
  const [center, setCenter] = useState(defaultPoint);
  const [currentDate, setCurrentDate] = useState(null);
  const [mapMoad, setMapLoad] = useState(false);
  const [cardInfo, setCardInfo] = useState(null);
  const [zoom] = useState(16);
  const [stagePointIndex, setStagePointIndex] = useState([]);
  const timerId = useRef(null);
  const isMoving = useRef(null);
  const p1 = useRef(null);

  const isStagePoint = points?.length ? checkIsStagePoint(points[sliderValue || 0]) : false;
  const currenPoint = points?.length ? points[sliderValue] : null;
  const onSelectDate = (value: string) => {
    if(isMoving.current) {
      isMoving.current = false;
      timerId.current && clearInterval(timerId.current);
    }
    setPoints([]);
    setCenter(defaultPoint);
    setSliderValue(0);
    setCurrentDate(value);
    setStagePointIndex([]);
    if(mapMoad) {
      getPositions(value, 0);
    }
  }
  const onChangeSlider = (value: any) => {
    setSliderValue(value);
    changePolyline(value);
    FridayService.addEvent('track_switching_location_click');
  }
  const onAfterChange = () => {
    FridayService.addEvent('track_switching_location_drag');
  }
  // 改变运动过折线的颜色
  const changePolyline = (value: any) => {
    const instanceMap = mapRef.current;
    const routePath = points.slice(0, value + 1).map((item: any) => {
      return instanceMap.createPoint({ lng: item.lon, lat: item.lat });
    });

    if(!p1.current) {
      const polyline1 = instanceMap.createPolyline(routePath, {
        strokeColor: '#256EFF',
        strokeStyle: 'solid',
        strokeOpacity: 1,
        strokeWeight: 8,
      });
      p1.current = polyline1;
      instanceMap.addOverlay(polyline1);
    }else {
      p1.current.setPath(routePath)
    }
  }

  //根据点范围调整地图视野
  const calcAreaPoints = (s?: any[]) => {
    const p = s || points;
    const instanceMap = mapRef.current;
    const v = p.map((item: any) => {
      return {
        lng: item.lon,
        lat: item.lat
      }
    })
    instanceMap.setViewport({
      points: v,
      margins: [140, 100, 50, 50]
    });
  }

  //绘制所有折线
  const drawPolyline = (value: any, data?: any[]) => {
    const instanceMap = mapRef.current;
    let pointDatas = data || points;
    renderMarks.current = false;
    if(pointDatas.length >= 2) {
      const arr =[];
      for(let i = 0; i <= pointDatas.length - 1; i++ ) {
        const point = instanceMap.createPoint({ lng: pointDatas[i].lon, lat: pointDatas[i].lat });
        arr.push(point);
      }
      if (arr.length > 1) { //两点确定一条直线,定位点大于1时才进行线段绘制
        const polyline = instanceMap.createPolyline(arr.reverse(), {
          strokeColor: '#689BFF',
          strokeStyle: 'solid',
          strokeOpacity: 1,
          strokeWeight: 8,
        });
        const polyline1 = instanceMap.createPolyline([], {
          strokeColor: '#256EFF',
          strokeStyle: 'solid',
          strokeOpacity: 1,
          strokeWeight: 8,
        });
        p1.current = polyline1;
        instanceMap.addOverlay(polyline);
        instanceMap.addOverlay(polyline1);
      }
    }
    setTimeout(() => {
      calcAreaPoints(pointDatas);
    }, 50)
  }

  const getPositions = async (value?: string, sValue?: number) => {
    //清除绘制的轨迹数据
    const instanceMap = mapRef.current;
    instanceMap.clearOverlays();
    const { data: result } = await Http.post(
      Api.GetTrajectoryV1,
      {
        sncode: params.current.sncode,
        queryTime: value || currentDate,
        company: params.current.company
      }
    );

    if(!result?.length) {
      const instanceMap = mapRef.current;
      instanceMap.clearOverlays();
      setPoints([])
      return;
    }
    const dataRes = result.map((item: any) => {
      const content = JSON.parse(item);
      const point = transformToBd09({ lng: content.lon, lat: content.lat });
      return {
        ...content,
        lon: point.lng,
        lat: point.lat,
      };
    });

    const pointDatas = dataRes;
    let pointArrs = [...pointDatas];
    let pointLength = 0;

    //处理没有名称和到达时间的点坐标（绑路点, 位置信息和时间取上一个点的）
    for(let i = 0; i < pointArrs.length; i++ ) {
      let item = pointArrs[i];
      if(!item.arriveTime || !item.locationName) {
        pointArrs[i].arriveTime = pointArrs[i - 1]?.arriveTime ? pointArrs[i - 1]?.arriveTime :  '';
        pointArrs[i].locationName = pointArrs[i - 1]?.locationName ? pointArrs[i - 1]?.locationName : '';
      }
    }

    //根据相邻两点间的距离判断是否要在两点间新增部分点
    let arr = []
    for(let i = 0;i < pointArrs.length - 1; i++) {
      const startPoint = pointArrs[i];
      const endPoint = pointArrs[i + 1];
      let distance = getDistance(startPoint, endPoint); //a点与b点的距离
      let range = 100; //单位为m
      if(distance > 100) { //如果距离大于50时再进行补充点
        let allPoints = getFillPoints(startPoint, endPoint, distance, range);
        arr.push(startPoint, ...allPoints)
      }else {
        arr.push(startPoint);
      }
    }
    arr.push(pointArrs[pointArrs.length - 1]);
    pointArrs = arr;
    if(pointLength) {
      renderMarks.current = true;
    }
    const ids: any = []
    pointArrs.forEach((item: any, index: number) => {
      if(checkIsStagePoint(item)) { ids.push(index);}
    })
    setStagePointIndex(ids);
    setPoints(pointArrs);
    if(pointArrs?.length) {
      drawPolyline(sValue !== undefined ? sValue : sliderValue, pointArrs);
    }else {
      const instanceMap = mapRef.current;
      instanceMap.clearOverlays();
    }
  }

  const getCardInfo = async() => {
    const { data } = await Http.post(Api.GetCardInfoBySncode,
      { snCode: params.current.sncode, company: params.current.company }
    )
    if(data) {
      setCardInfo(data);
    }
  }

  const onMapLoad = () => {
    setMapLoad(true);
    getPositions();
  }

  const getDateName = (currenPoint: any) => {
    let name = '';
    if(currenPoint?.arriveTime) {
      name = Filter.date((currenPoint?.arriveTime), 'cTime');
    }

    if(isStagePoint) {
      name = name = Filter.date((currenPoint?.arriveTime), 'cDate');
      const h = getStageTime(currenPoint?.arriveTime, currenPoint?.leaveTime)
      name = name + Filter.date((currenPoint?.arriveTime), 'hourWithMinute') +
        '-' + Filter.date((currenPoint?.leaveTime), 'hourWithMinute') + ' (停留' + h + ')';
    }
    return name;
  }

  const getLocationName = (currenPoint: any) => {
    let name = '';
    if(currenPoint?.bldgname) {
      name = (currenPoint?.locationName || '') + '（' +currenPoint?.bldgname + '）';
    }else {
      name = currenPoint?.locationName;
    }
    return name;
  }

  const renderMarkers = () => {
    let aPoints = points;
    let Items = [];

    if(!aPoints.length) {
      return null;
    }
    if(aPoints.length > 1) {
      Items = aPoints.map((item: any, index: number) => {
        if(checkIsStagePoint(item)) {
          if(sliderValue === index) {
            return (
              <CustomOverlay position={{ lng: item.lon, lat: item.lat }} zIndex={ 100 }>
                {
                  zoom >= 15 && parseInt(currenPoint?.precision) > 0 ? ( //当地图缩放层级约为15且精度范围不为0时显示精度圈
                    <div className="flex flex-center" styleName="marker-circle">
                      <div className="flex flex-center" styleName="marker-icon-wrapper" />
                      <div styleName="map-line">
                        <div styleName="map-line-text">{ currenPoint?.precision ? Math.ceil(currenPoint?.precision) + 'm' : '' }</div>
                      </div>
                    </div>
                  ) : (
                    <div
                      className="flex flex-center"
                      styleName="marker-icon-wrapper"
                      style={{ transform: 'translate(-50%, -50%)' }}
                    />
                  )
                }
              </CustomOverlay>
            )
          }
          return (
            <CustomOverlay position={{ lng: item.lon, lat: item.lat }} zIndex={ 99 } paneName="markerPane">
              <div className="flex flex-center"
                styleName="marker-wrapper"
                data-index={ index }
                style={ sliderValue <= index ? { borderColor: '#689BFF' } : {} }
              />
            </CustomOverlay>
          )
        }
        return null;
      });
      const AvatarItem = (
        <CustomOverlay
          position={{
            lng: aPoints[sliderValue || 0].lon,
            lat: aPoints[sliderValue || 0].lat
          }}
          zIndex={ 100 }
          paneName="floatPane"
        >
          <div className="flex" styleName="avatar-info">
            {
              currenPoint?.arriveTime ? (
                <div
                  className="flex"
                  styleName="avatar-label"

                >
                  { isStagePoint ? (
                      Filter.date((currenPoint?.arriveTime), 'time') + '-' + Filter.date((currenPoint?.leaveTime), 'time')
                    ) :  Filter.date((currenPoint?.arriveTime), 'time') }
                </div>
              ) : null
            }
            <div styleName="avatar-wrapper">
              <div styleName="avatar">
                <img
                  styleName="avatar-img"
                  src={ cardInfo?.headImageUrl || defaultAvatar } alt=""
                />
              </div>
            </div>
          </div>
        </CustomOverlay>
      )
      Items.push(AvatarItem);
    }else {
      Items = aPoints.map((item: any, index: number) => {
        return (
          <CustomOverlay position={{ lng: item.lon , lat: item.lat }}>
            <div className="flex" styleName="avatar-info">
              {
                isStagePoint ? (
                  <div className="flex flex-center" styleName="avatar-label">
                    { Filter.date((currenPoint?.arriveTime), 'time') + '-' + Filter.date((currenPoint?.leaveTime), 'time') }
                  </div>
                ) : null
              }
               <div styleName="avatar-wrapper">
                <div styleName="avatar">
                  <img
                    styleName="avatar-img"
                    src={ cardInfo?.headImageUrl || defaultAvatar } alt=""
                  />
                </div>
              </div>
            </div>
          </CustomOverlay>
        )
      })
    }
    return Items;
  }

  const getIconName = () => {
    let iconName = 'icon-position';
    switch(currenPoint.locationType) {
      case locationType.gps:
        iconName = 'icon-weixing';
        break;
      case locationType.wifi:
        iconName = 'icon-wifi';
        break;
      case locationType.lbs:
        iconName = 'icon-jizhan';
        break;
      //no default
    }
    return iconName;
  }
  const clickNavRightBtn = () => {
    BrowserHistory.push(`${PUBLIC_URL}/movepathmode${ window.location.search }`);
  }

  useEffect(() => {
    getCardInfo();
  }, [])

  return (
    <div style={{ width: '100%', height: document.body.clientHeight * 0.8 }}>
      <NavBar
        title={ (cardInfo?.userName || ('学生证' + params.current.sncode)) + '的轨迹' }
        rightBtnText="模式"
        onClickRightBtn={ clickNavRightBtn }
      />
      <BaseMap ref={mapRef} center={ center } onMapLoad={ onMapLoad } zoom={18}>
        { points?.length ? renderMarkers() : null }
      </BaseMap>
      <DateBar
        onSelectDate={ onSelectDate }
        selectDate={ currentDate }
        sncode={ params.current.sncode }
        company={ params.current.company }
      />
      <div
        className="flex"
        styleName="container"
      >
        <div className="flex" styleName="slider-wrapper">
          <div className="flex" styleName="slider">
            <ReactSlider
              className={ styles['horizontal-slider']}
              marks={ stagePointIndex }
              markClassName={styles['slider-mark']}
              min={ 0 }
              max={ points?.length >= 2 ? points?.length - 1 : 0 }
              disabled={ points?.length < 2 }
              value={ sliderValue }
              thumbActiveClassName={
                isStagePoint ? styles['slider-thumb-active'] : ''
              }
              thumbClassName={ styles['slider-thumb'] }
              trackClassName={ styles['slider-track'] }
              onChange={ onChangeSlider }
              onAfterChange={ onAfterChange }
              withTracks
            />
          </div>
        </div>
        <div styleName="time-text">
          { getDateName(currenPoint) }
        </div>
        <div className="flex" styleName="address-text">
          { currenPoint ? (
            <>
              <i className={ "flex iconfont " + getIconName() } styleName="icon-address" />
              <div styleName="address-info">
                <span>{ getLocationName(currenPoint) }</span>
                { currenPoint?.guardRegionName ? (
                  <span style={{ color: '#8D9199', fontSize: '.28rem' }}>
                    （ 在{ currenPoint?.guardRegionName }附近 ）
                  </span>
                ) : null }
                {
                  currenPoint?.precision ? (
                    <span style={{ color: '#8D9199', fontSize: '.28rem' }}>
                      &nbsp;范围精度约为{ Math.ceil(currenPoint?.precision) } 米
                    </span>
                  ) : null
                }
              </div>
            </>
          ) : '暂无追踪轨迹' }
        </div>
      </div>
    </div>
  )
}
export default MovePath;